import type { FetchTicketResponse } from "src/api/models";

export function createAssigneeMenuItem(
  ticket: FetchTicketResponse,
  selectRef: any,
  handlers: {
    updateTicketAssignee: (ticketId: string, assigneeId: string) => Promise<void>;
    onUpdateTicket: (ticket: FetchTicketResponse) => void;
  }
) {
  return {
    label: "Change Assignee",
    icon: "pi pi-user-plus",
    command: () => {
      const { onSelect } = selectRef?.openDrawer() || {};
      if (!onSelect) return;

      onSelect(async (entity: any) => {
        if (!ticket.id) return;
        await handlers.updateTicketAssignee(ticket.id, entity.id);
        handlers.onUpdateTicket({ ...ticket, assignee: entity });
      });
    }
  };
}
